import LogoutIcon from '@mui/icons-material/Logout';
import {
  BackToLoginBtnContainer,
  BackToLoginBtnContent,
  BackToLoginText,
} from './styles';
import { ReactNode } from 'react';

export interface IBackToLoginBtnContainer {
  children: ReactNode;
  onBtnClick: () => void;
}

const BackToLoginBtn = ({ onBtnClick, children }: IBackToLoginBtnContainer) => {
  return (
    <BackToLoginBtnContainer>
      <BackToLoginBtnContent onClick={onBtnClick}>
        <LogoutIcon sx={{ width: '24px', height: '24px' }} />
        <BackToLoginText>{children}</BackToLoginText>
      </BackToLoginBtnContent>
    </BackToLoginBtnContainer>
  );
};

export default BackToLoginBtn;
